import React, { useContext } from 'react';
import { GridWrapper, Heading, GridColumn, GridRow } from 'react-onei';
import styled from 'styled-components';

import ContactAccountOwnerMessage from './ContactAccountOwnerMessage';
import NewTemporaryPassword from './TemporaryPassword/NewTemporaryPassword';
import UseTemporaryPassword from './TemporaryPassword/UseTemporaryPassword';

import { MOBILE_TYPE, MULTIBAL_ACCOUNT } from '../../../helpers/account';
import UserContext from '../../../context/UserContext';
import ContactsItem from './ContactsItem';
import LiveboxContacts from './LiveboxContacts';

const Wrapper = styled.div`
  display: flex;
  flex-direction: ${props => props.reverse ? 'column-reverse' : 'column'};
`;

function ChoiceView() {
  const {
    identities,
    wording,
    contacts,
    serviceConf,
  } = useContext(UserContext);
  const {
    accountLevel,
    hasPostalAddress,
    isFirstConnection,
  } = identities;
  const { tempPasswordUrl } = serviceConf;
  const {
    WLOST_200,
    WLOST_205,
    WLOST_206,
    WLOST_207,
  } = wording;
  const liveboxContacts = contacts.filter(contact => contact.isLiveboxContact);
  const otcContacts = contacts.filter(contact => !contact.isLiveboxContact);

  const getTitle = () => {
    let title;

    if (otcContacts.length === 0) {
      title = WLOST_200
    } else if (otcContacts.length === 1) {
      const contact = otcContacts[0];
      title = contact.contactType === MOBILE_TYPE ? WLOST_205 : WLOST_206;
    } else {
      title = WLOST_207;
    }
    return (
      <Heading as="h4" id="no-contact-access" className="spacing-m" fullWidth>
        {title}
      </Heading>
    )
  }

  const getOptions = () => {
    if (
      liveboxContacts.length > 0 ||
      tempPasswordUrl ||
      hasPostalAddress
    ) {
      return (
        <GridRow>
          <GridColumn size={{ xs: 1, m: 10 / 12, l: 8 / 12 }}>
            {getTitle()}
            {liveboxContacts.length > 0 && <LiveboxContacts otcContacts={otcContacts} liveboxContacts={liveboxContacts} />}
            {accountLevel === MULTIBAL_ACCOUNT && <ContactAccountOwnerMessage />}
            <Wrapper reverse={isFirstConnection}>
              {hasPostalAddress && <NewTemporaryPassword />}
              {tempPasswordUrl && <UseTemporaryPassword />}
            </Wrapper>
          </GridColumn>
        </GridRow>
      )
    }
  }

  return (
    <GridWrapper id="choice-form">

      {otcContacts.length > 0 && <ContactsItem contacts={otcContacts} />}
      {getOptions()}

    </GridWrapper>
  )
}

export default ChoiceView;
